import { useState } from "react";
import type ColumnSuggestion from "../models/ColumnSuggestion";
import type UIColumnSuggestion from "../models/UIColumnSuggestion";
import { seenSuggestionsStorage } from "../services/storage/columnSuggestionsStorage";

type HookValue = {
    uiColumnSuggestions: readonly UIColumnSuggestion[];
    updateSeenSuggestions(columnSuggestions: readonly ColumnSuggestion[]): void;
    removeSeenSuggestions(columnNames: readonly string[]): void;
};

const useColumnSuggestionsWithLifecycle = (columnSuggestions: readonly ColumnSuggestion[]): HookValue => {
    const [seenSuggestions, setSeenSuggestions] = useState(() => seenSuggestionsStorage.retrieve());

    const createUISuggestions = (suggestions: readonly ColumnSuggestion[]): readonly UIColumnSuggestion[] => {
        return suggestions.map((suggestion) => ({
            ...suggestion,
            isNew: !seenSuggestions.includes(suggestion.field),
        }));
    };

    const updateSeenSuggestions = (columnSuggestions: readonly ColumnSuggestion[]): void => {
        const newSuggestions = columnSuggestions.map(({ field }) => field);

        setSeenSuggestions(newSuggestions);
        seenSuggestionsStorage.persist(newSuggestions);
    };

    const removeSeenSuggestions = (columnNames: readonly string[]): void => {
        const newSuggestions = seenSuggestions.filter((suggestion) => !columnNames.includes(suggestion));

        setSeenSuggestions(newSuggestions);
        seenSuggestionsStorage.persist(newSuggestions);
    };

    return {
        uiColumnSuggestions: createUISuggestions(columnSuggestions),
        updateSeenSuggestions,
        removeSeenSuggestions,
    };
};

export default useColumnSuggestionsWithLifecycle;
